import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';

import { ParticipantPriceType, ParticipantType } from '@cds/betting-offer';
import { EventOption } from '@frontend/sports/betting-offer/feature/model';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { StringDictionary } from '@frontend/sports/common/core/utils/extended-types';
import {
    FixtureParticipantPriceMap,
    GreyhoundParticipantDictionary,
    WinGameFixture,
    WinGameParticipant,
} from '@frontend/sports/racing/feature/models';
import { HorseRacingCommon } from '@frontend/sports/types/components/sitecore';

import { HorsesFixturePricingHelper } from '../../../../horse-racing-shared/services/horses-fixture-pricing-helper.service';
import { RacingService } from '../../../services/racing-service';

@Component({
    selector: 'ms-greyhounds-resulted-placed-participants',
    templateUrl: './greyhounds-resulted-placed-participants.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class GreyhoundsResultedPlacedParticipantsComponent implements OnChanges {
    @Input() participants: WinGameParticipant[];
    @Input() prices: FixtureParticipantPriceMap = {};
    @Input() isOptionBet = false;
    @Input() greyhoundTrapDogMapping: GreyhoundParticipantDictionary = {};
    @Input() isFavourites: boolean;
    @Input() participantOptionGroups: StringDictionary<EventOption[]>;
    @Input() placeTermValue: number | null;
    @Input() fixture: WinGameFixture;

    constructor(
        public sitecore: Sitecore,
        private racingService: RacingService,
        private horsesFixturePricingHelper: HorsesFixturePricingHelper,
    ) {}

    ngOnChanges(): void {
        if (this.isFavourites && this.isOptionBet) {
            this.participants = this.participants.slice(0, 1);
        }
        if (this.prices && !this.isOptionBet) {
            this.placeTermValue = this.racingService.getPlaceTermValue(this.participants);
        }
    }

    getParticipantCaption(participant: WinGameParticipant): string {
        const favourite = participant.properties!.type === ParticipantType.Favourite;
        const rank: number = participant.properties!.rank ? participant.properties!.rank : parseInt('');
        if (favourite || this.isFavourites) {
            return this.sitecore.greyhoundRacing.messages.Favourite;
        } else if (isNaN(rank)) {
            return '';
        } else if (rank <= 3) {
            return this.sitecore.horseRacing.common[rank as any as keyof HorseRacingCommon];
        } else {
            return `${rank + this.sitecore.horseRacing.common.nth}`;
        }
    }

    getParticipantOption(id: number) {
        const option = this.horsesFixturePricingHelper.getParticipantOptions(id, this.participantOptionGroups, ParticipantPriceType.Fixed);

        return option ? option?.nativePrice.toJSON() : undefined;
    }
}
